import React, { useEffect, useRef } from 'react';
import AllRoute from '../router'
import {ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import VisitorService from '../../utils/VisitorTracker';


const App = () => { 
  const previousPathRef = useRef(null);

  // Track visitor on initial load and page changes
  useEffect(() => {
    // Initialize tracking on first load
    VisitorService.init();
    
    // Track page changes
    const handleLocationChange = () => {
      const currentPath = window.location.pathname;
      
      // Only track if path has changed
      if (previousPathRef.current !== currentPath) {
        previousPathRef.current = currentPath;
        
        // Record page view (updates visit count if on same day)
        const today = new Date().toISOString().split('T')[0];
        const visitorId = VisitorService.getOrCreateVisitorId();
        VisitorService.recordVisit(visitorId, today);
      }
    };

    // Listen to popstate (browser back/forward)
    window.addEventListener('popstate', handleLocationChange);
    
    return () => {
      window.removeEventListener('popstate', handleLocationChange);
    };
  }, []);

  // Track on URL change (for internal navigation)
  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        // User came back to the tab - record visit
        VisitorService.init();
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);
    
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);

  return (
    <div className="App" id='scrool'>
          <AllRoute/>
          <ToastContainer/>
    </div>
  );
}

export default App;